__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@transifex/native", "7.1.3", () => (() => (__webpack_require__(1132))), 1);
			register("glamor", "2.20.40", () => (() => (__webpack_require__(2565))), 1);
			register("globalize", "1.1.1", () => (() => (__webpack_require__(1373))), 1);
			register("launchdarkly-react-client-sdk", "3.3.2", () => (() => (__webpack_require__(2566))), 1);
			register("lodash", "4.17.21", () => (() => (__webpack_require__(1057))), 1);
			register("react-dnd-latest", "11.1.3", () => (() => (__webpack_require__(2567))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(1383))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(2580))), 1);
			register("react-router-dom", "6.30.4", () => (() => (__webpack_require__(2581))), 1);
			register("react", "15.7.0", () => (() => (__webpack_require__(2582))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(1374))), 1);
			initExternal(3675);
			initExternal(3584);
			initExternal(3860);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};